<template>
  <div v-if="this.$store.getters.isSuperUser">
    <v-tabs
      v-model="selectedTab"
      background-color="pink lighten-2"
      grow
      icons-and-text
      dark
      class="mb-10"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-summary">
        Synthèse
      </v-tab>
      <v-tab href="#tab-usersDetails">
        Détails utilisateurs
      </v-tab>
      <v-tab href="#tab-videosDetails">
        Détails vidéos
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="tab-summary">
        <Summary></Summary>
      </v-tab-item>
      <v-tab-item value="tab-usersDetails">
        <UsersDetails></UsersDetails>
      </v-tab-item>
      <v-tab-item value="tab-videosDetails">
        <VideosDetails></VideosDetails>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Summary from "@/components/superUser/summary/forms/tabs/summary.vue";
import UsersDetails from "@/components/superUser/userDetail/forms/tabs/usersDetails.vue";
import VideosDetails from "@/components/superUser/videoDetail/forms/tabs/videosDetails.vue";

export default {
  name: "cockpit",
  components: {
    Summary,
    UsersDetails,
    VideosDetails,
  },
  data: () => ({
    selectedTab: null,
  }),
  
  watch: {
    selectedTab(value) {
      localStorage.selectedTab = value;
    }
  },

  mounted() {
    if (localStorage.selectedTab) {
       this.selectedTab = localStorage.selectedTab;
    } 
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients"},
      { title: "Gestion des comptes" },
    ]);
  },
};
</script>
